import { CreationStrategy } from '../types/creation';

export enum StrategyType {
  KOVRIFICATION = 'kovrification',
  BEST_MOMENTS = 'best_moments',
  C_ROLL = 'c_roll',
}

export const getStrategyType = (
  strategy: CreationStrategy,
  creationType?: string,
): StrategyType => {
  if (strategy.name) {
    const name = strategy.name.toLowerCase();
    if (name.includes('kovrification')) {
      return StrategyType.KOVRIFICATION;
    }
    if (name.includes('podcast_best_moments')) {
      return StrategyType.BEST_MOMENTS;
    }
    if (name.includes('c_roll')) {
      return StrategyType.C_ROLL;
    }
  }

  if (creationType) {
    const typeLower = creationType.toLowerCase();
    if (typeLower === 'podcast_best_moments') {
      return StrategyType.BEST_MOMENTS;
    }
    if (typeLower === 'c_roll') {
      return StrategyType.C_ROLL;
    }
  }

  return StrategyType.KOVRIFICATION;
};
